module.exports = __webpack_public_path__ + "img/mobile-4.1647373c.png";